import {GridFields} from '../../components-fields/grid-fields';

export const GridFrenchTranslation: GridFields = {
  ClearButton: 'Effacer',
  FilterButton: 'Filtrer',
  EnterValue: 'Entrer une valeur',
};
